import { Switch, Route } from 'react-router-dom';

import { ROUTES } from 'utils/routes';
import AuthCheck from './components/AuthCheck';

import { Login } from './pages/Login/Loadable';
import { Dashboard } from './pages/Dashboard/Loadable';
import { QuotesPage } from './pages/QuotesPage/Loadable';
import { QuoteRenewalsPage } from './pages/QuoteRenewalsPage/Loadable';
import { QuotesSearch } from './pages/QuotesSearch/Loadable';
import { QuotePage } from './pages/QuoteDetail/Loadable';
import { FinancePage } from './pages/Finance/Loadable';
import { RemittanceAdvice } from './pages/Finance/RemittanceAdvice/Loadable';
import { CreateTransaction } from './pages/Finance/CreateTransaction/Loadable';
import { Statements } from './pages/Finance/Statements/Loadable';
import { UserManagement } from './pages/Admin/UserManagement/Loadable';
import { BulkPolicyTransfer } from './pages/Admin/BulkPolicyTransfer/Loadable';
import { NotFoundPage } from './pages/NotFoundPage/Loadable';
import { Remittances } from './pages/Finance/Remittances/Loadable';
import { EmailActivity } from './pages/Finance/EmailActivity/Loadable';
import { BLUsers } from './pages/Admin/BLUsers/Loadable';
import { WelcomeEmail } from './pages/Admin/WelcomeEmail/Loadable';

import { Permissions, PermissionType } from './api/Permissions';
import { ClaimsHistory } from './pages/ClaimsHistory/Loadable';
import { ClaimsLanding } from './pages/ClaimsLanding/Loadable';

export default function Router() {
    return (
        <AuthCheck>
            <Switch>
                <Route exact path={ROUTES.Login} component={Login} />
                {/* DASHBOARD Route */}
                {Permissions.hasPermission(PermissionType.QuoteUnderwritingDetailsView) && <Route exact path={ROUTES.Dashboard} component={Dashboard} />}
                {Permissions.isClaimsOnly() && <Route exact path={ROUTES.Dashboard} component={ClaimsLanding} />}
                {/* UNDERWRITING Routes */}
                {Permissions.hasPermission(PermissionType.QuoteUnderwritingDetailsView) && <Route exact path={ROUTES.Underwriting.Home} component={QuotesPage} />}
                {Permissions.hasPermission(PermissionType.QuoteUnderwritingDetailsView) && <Route exact path={ROUTES.Underwriting.Renewals} component={QuoteRenewalsPage} />}
                {Permissions.hasPermission(PermissionType.QuoteUnderwritingDetailsView) && <Route exact path={ROUTES.Underwriting.Assigned} component={QuotesPage} />}
                {Permissions.hasPermission(PermissionType.QuoteUnderwritingDetailsView) && <Route exact path={ROUTES.Underwriting.Actioned} component={QuotesPage} />}
                {/* FINANCE Routes */}
                {Permissions.hasPermission(PermissionType.FinanceView) && <Route exact path={ROUTES.Finance.Home} component={FinancePage} />}
                {Permissions.hasPermission(PermissionType.FinanceView) && <Route exact path={ROUTES.Finance.Remittance} component={RemittanceAdvice} />}
                {Permissions.hasPermission(PermissionType.FinanceView) && <Route exact path={ROUTES.Finance.Remittances} component={Remittances} />}
                {Permissions.hasPermission(PermissionType.FinanceView) && <Route exact path={ROUTES.Finance.Create} component={CreateTransaction} />}
                {Permissions.hasPermission(PermissionType.FinanceView) && <Route exact path={ROUTES.Finance.Statements} component={Statements} />}
                {Permissions.hasPermission(PermissionType.FinanceView) && <Route exact path={ROUTES.Finance.EmailActivity} component={EmailActivity} />}
                {/* CLAIM HISTORY Routes */}
                {Permissions.hasPermission(PermissionType.ClaimsHistoryView) && <Route exact path={ROUTES.Underwriting.ClaimsHistory} component={ClaimsHistory} />}
                {/* ADMIN Routes */}
                {Permissions.hasPermission(PermissionType.Administration) && <Route exact path={ROUTES.Admin.Users} component={UserManagement} />}
                {Permissions.hasPermission(PermissionType.Administration) && <Route exact path={ROUTES.Admin.BulkPolicyTransfer} component={BulkPolicyTransfer} />}
                {/* SEARCH Route */}
                {Permissions.hasPermission(PermissionType.QuoteSearch) && <Route path={ROUTES.Search} component={QuotesSearch} />}
                {/* QUOTE Route */}
                {Permissions.hasPermission(PermissionType.QuoteView) && <Route exact path={Object.values(ROUTES.Quote)} component={QuotePage} />}
                {(Permissions.hasPermission(PermissionType.AdministrationBlUser) || Permissions.hasPermission(PermissionType.AdministrationUnblock)) && <Route exact path={ROUTES.Admin.BLUsers} component={BLUsers} />}
                {Permissions.hasPermission(PermissionType.AdministrationWelcomeEmail) && <Route exact path={ROUTES.Admin.WelcomeEmail} component={WelcomeEmail} />}
                <Route component={NotFoundPage} />
            </Switch>
        </AuthCheck>
    );
}
